import { ApiClientError, request } from "./client";

export type Availability = "AVAILABLE" | "SOLD_OUT";
export type AdjustmentType = "ADJUST" | "DAMAGE" | "LOSS" | "PROFIT";

export interface InventoryView {
  id: string;
  skuId: string;
  baseUnit: "PIECE";
  actualQty: number;
  lockedQty: number;
  availableQty: number;
  soldQty: number;
  availability: Availability;
  initializedAt: string;
  updatedAt: string;
}

export interface InventoryLog {
  id: string;
  type: "INIT" | AdjustmentType;
  beforeActualQty: number;
  afterActualQty: number;
  changeQty: number;
  operationSource: string;
  operatorId: string;
  reason: string | null;
  createdAt: string;
}

export async function getInventory(skuId: string): Promise<InventoryView | null> {
  try {
    return (await request<InventoryView>(`/admin/inventory/skus/${skuId}`)).data;
  } catch (error) {
    if (error instanceof ApiClientError && error.code === "INVENTORY_NOT_INITIALIZED") return null;
    throw error;
  }
}

export async function initializeInventory(
  skuId: string,
  initialQty: number,
  reason: string,
): Promise<InventoryView> {
  return (
    await request<InventoryView>(`/admin/inventory/skus/${skuId}/initialize`, {
      method: "POST",
      body: JSON.stringify({ initialQty, reason }),
    })
  ).data;
}

export async function adjustInventory(
  skuId: string,
  input: { type: AdjustmentType; changeQty: number; reason: string },
): Promise<InventoryView> {
  return (
    await request<{ inventory: InventoryView }>(`/admin/inventory/skus/${skuId}/adjustments`, {
      method: "POST",
      body: JSON.stringify(input),
    })
  ).data.inventory;
}

export async function listInventoryLogs(skuId: string): Promise<InventoryLog[]> {
  return (
    await request<{ items: InventoryLog[] }>(`/admin/inventory/skus/${skuId}/logs?page=1&pageSize=100`)
  ).data.items;
}
